import * as React from "react";
const SvgFiRrSpa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spa_svg__a)">
      <path
        fill="#062147"
        d="M19.367 14.727A4.15 4.15 0 0 0 22 11c0-2.622-2.5-4.354-6.8-4.849.518-.597.802-1.36.8-2.151 0-2.43-2.355-4-6-4S4 1.57 4 4a3.46 3.46 0 0 0 1.9 3.051C3.624 8.052 3 9.606 3 11a4 4 0 0 0 2.229 3.614C1.793 15.38 0 16.857 0 19c0 3.271 4.149 5 12 5 7.963 0 12-1.682 12-5 0-2.057-1.555-3.484-4.633-4.273M10 2c1.991 0 4 .619 4 2s-2.009 2-4 2-4-.619-4-2 2.009-2 4-2m2.5 6c3.46 0 7.5.786 7.5 3s-4.04 3-7.5 3c-2.255 0-7.5-.292-7.5-3s5.245-3 7.5-3M12 22c-6.075 0-10-1.178-10-3s3.925-3 10-3c6.262 0 10 1.122 10 3s-3.738 3-10 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpa;
